import "core-js/modules/es.array.push.js";
import { useCssVars as _useCssVars } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/icon/My-B.svg';
import _imports_1 from '../../assets/icon/My.svg';
import _imports_2 from '@/assets/home/item30.png';
import _imports_3 from '@/assets/home/item31.png';
import _imports_4 from '@/assets/home/item32.png';
import _imports_5 from '@/assets/loan.svg';

const _withScopeId = n => (_pushScopeId("data-v-66ddb9b4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "home-container"
};
const _hoisted_2 = {
  style: {
    "font-size": "22px",
    "font-weight": "700",
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "ICLightMode_svg__icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#1D1D1D"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M554.656 85.312a42.656 42.656 0 00-85.312 0v64a42.656 42.656 0 0085.312 0v-64zm-374.56 94.784a42.656 42.656 0 0160.352 0l45.248 45.248a42.656 42.656 0 11-60.352 60.352l-45.248-45.248a42.656 42.656 0 010-60.352zM42.656 512c0-23.552 19.104-42.656 42.656-42.656h64a42.656 42.656 0 010 85.312h-64A42.656 42.656 0 0142.656 512zm243.072 286.592a42.656 42.656 0 10-60.352-60.352l-45.248 45.248a42.656 42.656 0 1060.352 60.352l45.248-45.248zm452.544-60.256a42.656 42.656 0 0160.352 0l45.248 45.248a42.656 42.656 0 11-60.352 60.352l-45.248-45.248a42.656 42.656 0 010-60.352zm136.384-269.024a42.656 42.656 0 000 85.312h64a42.656 42.656 0 000-85.312h-64zM843.872 180.16a42.656 42.656 0 010 60.352l-45.248 45.248a42.656 42.656 0 11-60.352-60.352l45.248-45.248a42.656 42.656 0 0160.352 0z"
}, null, -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M225.536 512A286.496 286.496 0 11512 798.496 286.464 286.464 0 01225.536 512zM512 310.848a201.152 201.152 0 100 402.304 201.152 201.152 0 000-402.304zm42.656 563.872a42.656 42.656 0 00-85.312 0v64a42.656 42.656 0 0085.312 0v-64z"
}, null, -1));

const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = {
  key: 1,
  class: "ICDarkMode_svg__icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#F3F3F3"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M416.16 179.392c-140.8 33.568-245.504 160.192-245.504 311.296 0 176.736 143.264 320 320 320 151.072 0 277.696-104.704 311.296-245.504a273.44 273.44 0 01-385.76-385.76zM85.344 490.656c0-223.872 181.472-405.344 405.344-405.344 28.096 0 55.552 2.848 82.08 8.32a42.656 42.656 0 012.144 83.072A188.128 188.128 0 10804.576 406.4a42.656 42.656 0 0183.072 2.144c5.472 26.528 8.32 54.016 8.32 82.08 0 223.872-181.472 405.344-405.344 405.344S85.28 714.496 85.28 490.624z"
}, null, -1));

const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = {
  class: "home-content"
};
const _hoisted_11 = {
  class: "assets"
};
const _hoisted_12 = {
  class: "left"
};
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = {
  class: "money"
};
const _hoisted_15 = {
  class: "number"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "coin"
}, "USD", -1));

const _hoisted_17 = {
  class: "right"
};
const _hoisted_18 = {
  class: "tab"
};

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
})], -1));

const _hoisted_20 = {
  class: "title"
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
})], -1));

const _hoisted_22 = {
  class: "title"
};

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
})], -1));

const _hoisted_24 = {
  class: "title"
};
const _hoisted_25 = {
  class: "tab pledge-tab"
};

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
})], -1));

const _hoisted_27 = {
  class: "title"
};

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "home-footer",
  style: {
    "padding-bottom": "30px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "home-footer-bottom"
}, [/*#__PURE__*/_createElementVNode("div", null, "FTZINC © 2026"), /*#__PURE__*/_createElementVNode("div", null, "support@ftzcoininc.com")])], -1));

import router from '@/router';
import store from '@/store';
import { useRoute } from 'vue-router';
import { useI18n } from "vue-i18n";
import { ref, onActivated, onDeactivated, onBeforeMount, computed } from 'vue'; // import { AppleOutlined, ArrowRightOutlined } from '@ant-design/icons-vue'
// import PriceCard from '@/components/PriceCard.vue'

import LangChange from '@/components/LangChange.vue';
import { homeInfo, announceDetail, userInfo, marketInfoRecharge, marketIeo, getUserAsset } from '@/apis'; // import { Dialog } from 'vant'

import 'vant/es/dialog/style';
import BigNumber from 'bignumber.js';
import moment from 'moment';
import { getPledgeLoanCopy } from '@/util/pledgeLoan';
import NoticePopup from '@/components/NoticePopup.vue';
import HomeNotice from '@/components/home1/HomeNotice.vue';
import HomeMarketList from '@/components/home1/HomeMarketList.vue';
import HomeFeatureCards from '@/components/home1/HomeFeatureCards.vue';
import HomeEcosystem from '@/components/home1/HomeEcosystem.vue';
import HomeLearnCards from '@/components/home1/HomeLearnCards.vue';
import HomeVoices from '@/components/home1/HomeVoices.vue';
import { hasSeenNoticePopup, markNoticePopupSeen } from '@/util/noticePopup';
export default {
  __name: 'HomeTab',
  emits: ["changeColor"],

  setup(__props, {
    emit
  }) {
    _useCssVars(_ctx => ({
      "78647d56": _ctx.backgroundColor,
      "dc4b70d6": _ctx.fontColor
    }));

    const route = useRoute();
    const {
      t,
      setLocaleMessage,
      locale
    } = useI18n();
    const pledgeCopy = computed(() => getPledgeLoanCopy(t));
    const isLight = ref(true);
    onBeforeMount(() => {
      if (localStorage.getItem('isLight') == undefined || localStorage.getItem('isLight') == null) {
        localStorage.setItem('isLight', true);
      } else {
        isLight.value = Boolean(localStorage.getItem('isLight') == 'true');
      }

      getIcon();
    });

    const changeColor = () => {
      emit('changeColor', isLight.value);
    };

    const coinList = ref([]);

    const getIcon = async () => {
      const res = await marketInfoRecharge({});

      if (res.code === 200 && res.data) {
        coinList.value = res.data.map(item => {
          const data = {
            id: item.id,
            icon: process.env.VUE_APP_IMG + item.icon,
            name: item.marketName,
            min: item.rechargeMin,
            symbol: item.marketSymbol
          };
          return data;
        });
      }
    }; // const registerValue = ref('')


    const time = ref(300000000);
    const buyInfo = ref({
      icon: '',
      name: '',
      symbol: ''
    });

    const getMarketIeo = () => {
      marketIeo({}).then(res => {
        if (res.code === 200 && res.data) {
          buyInfo.value.icon = process.env.VUE_APP_IMG + res.data.icon;
          buyInfo.value.name = res.data.marketName;
          buyInfo.value.symbol = res.data.marketSymbol;
        }
      });
    };

    let appShow = true;

    if (route.query.platform) {
      appShow = false;
    }

    store.commit('appShowChange', appShow);

    const getEmail = async () => {
      const res = await userInfo();

      if (res.code === 200 && res.data) {
        store.commit('emailChange', res.data.email);
        localStorage.setItem('astore_info', JSON.stringify({
          token: store.state.token,
          time: moment().unix(),
          email: store.state.email
        }));
      }
    };

    let sessionReady = Promise.resolve();

    if (route.query.token) {
      store.commit('tokenChange', route.query.token);
      sessionReady = getEmail().catch(() => undefined);
    }

    const bulletinList = ref([]);
    const noticePopupVisible = ref(false);
    const noticePopupNotice = ref(null); // const homeMenu = [
    //   {
    //     key: 'recharge',
    //     icon: require("../../assets/icon/recharge.png")
    //   },
    //   // {
    //   //   key: 'invite',
    //   //   icon: require("../../assets/icon/invite.png")
    //   // },
    //   {
    //     key: 'withdraw',
    //     icon: require("../../assets/icon/refund.png")
    //   },
    //   {
    //     key: 'contact',
    //     icon: require("../../assets/icon/contact.png")
    //   },
    //   // {
    //   //   key: 'fastTrade',
    //   //   icon: require("../../assets/icon/second.png")
    //   // }
    // ]

    let dataTimer = null;
    const homeList = ref({}); // const initLoading = ref(false)

    const langSelect = lang => {
      localStorage.setItem('websetlang', lang);
      store.commit('langChange', lang);

      try {
        const msg = require(`@/language/lang/${lang}`).default;

        setLocaleMessage(lang, msg);
        locale.value = lang;
        init();
      } catch (err) {
        console.warn(err);
      }
    };

    const dataChange = () => {
      dataTimer = setInterval(() => {
        homeList.value = { ...store.state.market
        };
      }, 1000);
    };

    onActivated(async () => {
      await sessionReady;
      homeList.value = { ...store.state.market
      };
      dataChange();
      init();
      getMarketIeo();
      time.value = 1757260800000 - new Date().getTime();
      assetInit();
      tradeInit();
    });
    onDeactivated(() => {
      clearInterval(dataTimer);
    }); // const onRefresh = () => {
    //   initLoading.value = true
    //   init().finally(() => { initLoading.value = false })
    // }
    // const menuSelect = (index) => {
    //   switch(index) {
    //     case 0:
    //       router.push({ name: 'recharge' })
    //       break
    //     case 1:
    //       if (store.state.token !== '') {
    //         router.push({ name: 'withdraw' })
    //       } else {
    //         router.push({ name: 'login' })
    //       }
    //       break
    //     case 2:
    //       Dialog({
    //         title: 'Email',
    //         message: 'support@ftzcoininc.com',
    //         confirmButtonText: t('confirmText'),
    //       })
    //       break;
    //   }
    // }

    const showLatestNoticePopup = async latestNotice => {
      const token = store.state.token;
      const email = store.state.email;
      if (!latestNotice || hasSeenNoticePopup(latestNotice.id, token, email)) return;

      try {
        const res = await announceDetail({
          id: Number(latestNotice.id)
        });
        if (res.code !== 200 || !res.data) return;
        noticePopupNotice.value = { ...latestNotice,
          title: res.data.title || latestNotice.title,
          content: res.data.content || '',
          time: latestNotice.time
        };
        markNoticePopupSeen(latestNotice.id, token, email);
        noticePopupVisible.value = true;
      } catch (error) {
        console.warn('Unable to load notice popup', error);
      }
    };

    const init = async () => {
      try {
        const newRes = await homeInfo({
          platform: 1
        });

        if (newRes.code === 200 && newRes.data) {
          const list = Array.isArray(newRes.data) ? newRes.data : JSON.parse(newRes.data);
          bulletinList.value = list.map(item => {
            return {
              id: item.id,
              title: item.title,
              time: item.createdDate
            };
          });
          await showLatestNoticePopup(bulletinList.value[0]);
        }
      } catch (error) {
        console.warn('Unable to load announcements', error);
      }
    }; // const download = () => {
    //   //网页链接合成
    //   let address = ''
    //   let arr = window.location.host.split('.')
    //   if(arr.length == 3 && arr[0] == 'pc'){
    //     address = arr[1] + '.' + arr[2]
    //   }else if(arr.length == 3 && arr[0] == 'www'){
    //     address = arr[1] + '.' + arr[2]
    //   }else{
    //     address = arr[0] + '.' + arr[1]
    //   }
    //   window.open('https://' + address + '/FTZINC.apk')
    // }
    // const download1 = () => {
    //   //网页链接合成
    //   let address = ''
    //   let arr = window.location.host.split('.')
    //   if(arr.length == 3 && arr[0] == 'pc'){
    //     address = arr[1] + '.' + arr[2]
    //   }else if(arr.length == 3 && arr[0] == 'www'){
    //     address = arr[1] + '.' + arr[2]
    //   }else{
    //     address = arr[0] + '.' + arr[1]
    //   }
    //   window.open('https://' + address + '/download/FTZCOIN.mobileconfig')
    // }


    const allTotal = computed(() => {
      return BigNumber(currencyTotal.value).plus(contractTotal.value).toFixed(5);
    });
    const currencyList = ref([]);
    const contractTotal = ref('0');
    const contractList = ref([]);
    const spotList = ref([]);
    const currencyTotal = computed(() => {
      let all = 0;

      if (spotList.value.length > 0) {
        spotList.value.map(item => {
          let allUsd = '0';
          allUsd = (Number(item.active + item.frozen + item.futureFrozen) * Number(store.state.market[item.marketSymbol]?.last)).toFixed(8);

          if (item.marketSymbol == 'USDT') {
            allUsd = item.active.toFixed(5);
          }

          all = BigNumber(all).plus(allUsd);
        });
      }

      all = Number(all);
      return Number.isNaN(all) || !Number.isFinite(all) ? 0 : all.toFixed(5);
    });

    const assetInit = () => {
      getUserAsset({
        platform: 0
      }).then(res => {
        if (res.code === 200 && res.data) {
          spotList.value = res.data;
          let total = 0;
          currencyList.value = res.data.map(item => {
            const freeze = res.data.length != 0 ? Math.floor((item.frozen + item.futureFrozen) * 100000) / 100000 : '0';
            const active = res.data.length != 0 ? Math.floor(item.active * 100000) / 100000 : '0';
            let allUsd = '0';
            allUsd = item.active + item.frozen + item.futureFrozen;

            if (item.marketSymbol == 'USDT') {
              allUsd = Math.floor(item.active * 100000) / 100000;
            }

            return {
              id: item.marketId,
              icon: item.icon,
              name: item.marketName,
              symbol: item.marketSymbol,
              freeze: freeze,
              active: active,
              usd: Number(allUsd)
            };
          });
          currencyTotal.value = total.toFixed(5);
        }
      });
    };

    const tradeInit = () => {
      getUserAsset({
        platform: 1
      }).then(res => {
        if (res.code === 200 && res.data) {
          const findItem = res.data.find(item => item.marketName === 'USDT');

          if (findItem) {
            const frozen = findItem ? Math.floor((findItem.frozen + findItem.futureFrozen) * 100000) / 100000 : '0';
            const active = findItem ? Math.floor(findItem.active * 100000) / 100000 : '0';
            const allUsd = findItem ? Math.floor(findItem.active * 100000) / 100000 : '0';
            contractList.value = [{
              id: findItem.marketId,
              icon: findItem.icon,
              name: findItem.marketName,
              symbol: findItem.marketSymbol,
              freeze: frozen,
              active: active,
              usd: Number(allUsd)
            }];
            contractTotal.value = allUsd;
          }
        }
      });
    };

    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");

      const _component_van_nav_bar = _resolveComponent("van-nav-bar");

      const _component_a_button = _resolveComponent("a-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        class: "home-nb",
        "safe-area-inset-top": true,
        fixed: true,
        placeholder: true,
        border: false,
        "z-index": "200"
      }, {
        left: _withCtx(() => [isLight.value ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _imports_0,
          style: {
            "width": "20px",
            "margin-left": "-5px",
            "margin-right": "5px"
          },
          onClick: _cache[0] || (_cache[0] = $event => _unref(router).push({
            name: 'user'
          }))
        })) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _imports_1,
          style: {
            "width": "20px",
            "margin-left": "-5px",
            "margin-right": "5px"
          },
          onClick: _cache[1] || (_cache[1] = $event => _unref(router).push({
            name: 'user'
          }))
        }))]),
        right: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_unref(store).state.token === '' ? (_openBlock(), _createBlock(_component_van_button, {
          key: 0,
          type: "primary",
          size: "small",
          onClick: _cache[2] || (_cache[2] = $event => _unref(router).push({
            name: 'login'
          })),
          style: {
            "--van-button-small-height": "30px",
            "--van-button-small-padding": "0 5px",
            "background-color": "var(--bg-color)",
            "border-color": "var(--bg-color)",
            "color": "var(--text-color)",
            "margin-right": "5px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('login')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _unref(store).state.token === '' ? (_openBlock(), _createBlock(_component_van_button, {
          key: 1,
          type: "primary",
          size: "small",
          onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
            name: 'register'
          })),
          style: {
            "--van-button-small-height": "30px",
            "--van-button-small-padding": "0 5px",
            "background-color": "var(--text-color)",
            "border-color": "var(--text-color)",
            "color": "var(--bg-color)",
            "margin-right": "10px",
            "border-radius": "15px",
            "padding": "0 10px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('register')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(LangChange, {
          onSelect: langSelect
        }), _createElementVNode("div", {
          onClick: _cache[4] || (_cache[4] = $event => {
            isLight.value = !isLight.value;
            changeColor();
          }),
          style: {
            "margin-left": "20px",
            "display": "flex",
            "align-items": "center"
          }
        }, [isLight.value ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_6)) : (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))])])]),
        _: 1
      }), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('homeremind212')), 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_unref(allTotal)), 1), _hoisted_16])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_a_button, {
        type: "primary",
        onClick: _cache[5] || (_cache[5] = $event => _unref(router).push({
          name: 'recharge'
        })),
        style: {
          "background-color": "var(--text-color)",
          "border-color": "var(--text-color)",
          "color": "var(--bg-color)",
          "height": "40px",
          "border-radius": "30px",
          "font-weight": "600"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('homeremind213')), 1)]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
        class: "item",
        onClick: _cache[6] || (_cache[6] = $event => _unref(router).push({
          name: 'trade'
        }))
      }, [_hoisted_19, _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('homeremind214')), 1)]), _createElementVNode("div", {
        class: "item",
        onClick: _cache[7] || (_cache[7] = $event => _unref(router).push({
          name: 'futures'
        }))
      }, [_hoisted_21, _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('homeremind215')), 1)]), _createElementVNode("div", {
        class: "item",
        onClick: _cache[8] || (_cache[8] = $event => _unref(router).push({
          name: 'ieo'
        }))
      }, [_hoisted_23, _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('homeremind216')), 1)])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", {
        class: "item",
        onClick: _cache[9] || (_cache[9] = $event => _unref(router).push({
          name: 'pledgeLoan'
        }))
      }, [_hoisted_26, _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(pledgeCopy).name), 1)])]), _createVNode(HomeNotice, {
        items: bulletinList.value
      }, null, 8, ["items"]), _createVNode(HomeMarketList), _createVNode(HomeFeatureCards), _createVNode(HomeEcosystem), _createVNode(HomeLearnCards), _createVNode(HomeVoices), _hoisted_28]), noticePopupNotice.value ? (_openBlock(), _createBlock(NoticePopup, {
        key: 0,
        modelValue: noticePopupVisible.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => noticePopupVisible.value = $event),
        notice: noticePopupNotice.value
      }, null, 8, ["modelValue", "notice"])) : _createCommentVNode("", true)]);
    };
  }

};